import type { ReactElement } from 'react';

/**
 * 소셜 로그인 제공사 심볼.
 *
 * 두 마크 모두 각 사의 브랜드 가이드가 형태·색 변경을 금지한다 —
 * 카카오 말풍선은 단색(노란 버튼 위에서는 검정), 네이버 N 은 초록 버튼 위 흰색이다.
 * 둘 다 버튼의 글자색을 따르므로 currentColor 로 그린다.
 */

/** 카카오 말풍선. 버튼의 글자색을 그대로 따라간다. */
export function KakaoMark({ className }: { className?: string }): ReactElement {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
      <path d="M12 3.5c-5.06 0-9.16 3.2-9.16 7.15 0 2.53 1.68 4.75 4.2 6.01-.18.65-.67 2.42-.77 2.8-.12.47.17.47.36.34.15-.1 2.4-1.63 3.37-2.29.65.1 1.32.15 2 .15 5.06 0 9.16-3.2 9.16-7.01S17.06 3.5 12 3.5Z" />
    </svg>
  );
}

/** 네이버 N. 초록 면(#03C75A) 위 흰색이 규정이라 버튼 글자색을 따른다. */
export function NaverMark({ className }: { className?: string }): ReactElement {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className={className}>
      <path d="M11.63 10.7 8.2 5.75H5.4v8.5h2.97V9.3l3.43 4.95h2.8v-8.5h-2.97v4.95Z" />
    </svg>
  );
}
